import type { ScholarshipApplication } from '@olagg/db-types'
import { useState } from 'react'
import { ScholarshipsEndpoints } from '../endpoints/endpoints'
import { fetcher } from '../fetcher'

const useScholarship = () => {

  const [scholarship, setScholarship] = useState<ScholarshipApplication | null>(null);
  const [scholarships, setScholarships] = useState<ScholarshipApplication[] | null>(null);

  const getMyScholarships = () =>
    fetcher(ScholarshipsEndpoints.myScholarships())
      .then((data) => {
        setScholarship(data.scholarships)
        return data.scholarships
      }).catch(() => setScholarship(null))

  const getScholarship = (slug: string) =>
    fetcher(ScholarshipsEndpoints.myScholarship(slug))
      .then((data) => {
        setScholarships(data.scholarship)
        return data.scholarship
      }).catch(() => setScholarship(null))

  return {
    scholarship,
    scholarships,
    getScholarship,
    getMyScholarships
  }
}

export default useScholarship
